import { render } from "./BillingClosedContainer.vue?vue&type=template&id=d8cccc98"
import script from "./BillingClosedContainer.vue?vue&type=script&lang=js"
export * from "./BillingClosedContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__